export default __webpack_public_path__ + "static/media/Image4.4dceb488.png";